import { render, staticRenderFns } from "./in-app-announcement-accept-all-agreemetns.vue?vue&type=template&id=45bb4882&scoped=true&"
import script from "./in-app-announcement-accept-all-agreemetns.vue?vue&type=script&lang=js&"
export * from "./in-app-announcement-accept-all-agreemetns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bb4882",
  null
  
)

export default component.exports